import { CloneType } from "src/@types/cloneTypes";

export enum CloneFields {
  id = "id",
  cloneType = "clone_type",
  companyName = "company_name",
  companyPresentation = "company_presentation",
  googleProfile = "google_profile",
  industry = "industry",
  website = "website",
  describeProduct = "describe_product",
  advantages = "advantages",
  investmentForStart = "investment_for_start",
  yearsOnMarket = "years_on_market",
  customersCount = "customers_count",
  companyTurnoverMin = "company_turnover_min",
  companyTurnoverMax = "company_turnover_max",
  averageTurnover = "average_turnover",
  readyToAuthorizedCapital = "ready_to_authorized_capital",
  patentsBrands = "patents_brands",
  cloneCost = "clone_cost",
  activities = "activities",
  companyClients = "company_clients",
  patentsBrandsText = "patents_brands_text",
  supportBuyer = "support_buyer",
  informationSold = "information_sold",
  logo = "logo",
  mainPhoto = "main_photo",
  additionalInformation = "additional_information",
  employees = "employees",
  monthlyIncomeMin = "monthly_income_min",
  monthlyIncomeMax = "monthly_income_max",
  accessToProduction = "access_to_production",
  prohibitedCountries = "prohibited_countries",
}

export interface ICloneSettingsFormValues {
  clone_type: CloneType;
  company_name: string;
  company_presentation: File[];
  google_profile: string;
  industry: string;
  website: string;
  describe_product: string;
  advantages: string;
  investment_for_start: number;
  years_on_market: string;
  customers_count: string;
  company_turnover_min: number;
  company_turnover_max: number;
  ready_to_authorized_capital: boolean;
  clone_cost: number;
  activities: string;
  company_clients: string;
  patents_brands: boolean;
  patents_brands_text: string;
  support_buyer: string;
  information_sold: string[];
  logo: File;
  main_photo: File;
  additional_information: string;
  employees: string;
  monthly_income_min: number;
  monthly_income_max: number;
  access_to_production: boolean;
  prohibited_countries: string[];
}
